import PropTypes from "prop-types";

import { Box } from "../../../../../../../wsui/base";
import ModuleWrapper from "../../../components/ModuleWrapper.js";

import * as defaultStyles from "./NoticeModule.module.css";

NoticeModule.propTypes = {
  className: PropTypes.string,
  styles: PropTypes.objectOf(PropTypes.string),
  title: PropTypes.any,
  module: PropTypes.shape({
    modNoticeOptions: PropTypes.shape({
      content: PropTypes.string,
      button: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
      }),
      bodyLink: PropTypes.shape({
        url: PropTypes.string,
        title: PropTypes.string,
      }),
    }),
  }),
};

export default function NoticeModule({
  module: { modNoticeOptions },
  styles = defaultStyles,
  title,
  ...restProps
}) {
  const { noticeText, button, bodyLink } = modNoticeOptions || {};

  return (
    <ModuleWrapper
      as={Box}
      border={false}
      title={title && <span className={styles.title}>{title}</span>}
      className={styles.component}
      styles={styles}
      {...restProps}
    >
      <div className={styles.noticeText}>{noticeText}</div>

      {(button || bodyLink) && (
        <div className={styles.linkWrapper}>
          {button && (
            <a href={button.url} className={styles.button}>
              {button.title}
            </a>
          )}
          {bodyLink && (
            <div className={styles.bodyLinkwrapper}>
              <a href={bodyLink.url} className={styles.bodyLink}>
                {bodyLink.title}
              </a>
              <span aria-hidden="true"> →</span>
            </div>
          )}
        </div>
      )}
    </ModuleWrapper>
  );
}
